import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Quote: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_30175)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24 5.12836C24 4.31459 23.6763 3.5332 23.1014 2.9572C22.5254 2.38231 21.744 2.05859 20.9302 2.05859C16.6527 2.05859 7.34735 2.05859 3.06977 2.05859C2.256 2.05859 1.4746 2.38231 0.898605 2.9572C0.323721 3.5332 0 4.31459 0 5.12836V16.2911C0 17.9868 1.37414 19.3609 3.06977 19.3609H4.18605C4.34009 19.3609 4.46512 19.4859 4.46512 19.64V20.6658C4.46512 21.4171 4.896 22.1014 5.57247 22.4273C6.24893 22.7522 7.05265 22.6606 7.6387 22.1918L11.1014 19.4223C11.1505 19.3821 11.2119 19.3609 11.2755 19.3609H20.9302C21.744 19.3609 22.5254 19.0372 23.1014 18.4623C23.6763 17.8863 24 17.1049 24 16.2911V5.12836ZM22.3256 5.12836V16.2911C22.3256 16.6618 22.1782 17.0156 21.917 17.2779C21.6547 17.5392 21.3008 17.6865 20.9302 17.6865H11.2755C10.8313 17.6865 10.4015 17.8372 10.0554 18.114L6.59274 20.8846C6.50902 20.9516 6.39405 20.9639 6.29805 20.9181C6.20093 20.8712 6.13953 20.773 6.13953 20.6658V19.64C6.13953 18.5605 5.26549 17.6865 4.18605 17.6865H3.06977C2.29954 17.6865 1.67442 17.0614 1.67442 16.2911V5.12836C1.67442 4.75776 1.82177 4.4039 2.08298 4.14157C2.3453 3.88036 2.69916 3.73301 3.06977 3.73301H20.9302C21.3008 3.73301 21.6547 3.88036 21.917 4.14157C22.1782 4.4039 22.3256 4.75776 22.3256 5.12836Z'
          fill='url(#paint0_linear_12280_30175)'
          stroke='url(#paint1_linear_12280_30175)'
          strokeWidth='0.3'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.1979 13.3371C12.8195 12.8772 12.4534 12.0734 12.5684 10.6691C12.7537 8.39194 15.2251 7.32031 15.2251 7.32031L15.6794 8.01241C15.6794 8.01241 14.2885 8.76366 14.4136 10.4939C14.4973 10.4827 14.581 10.4771 14.667 10.4771C15.6649 10.4771 16.4753 11.2865 16.4753 12.2844C16.4753 13.2812 15.6649 14.0917 14.667 14.0917C14.4013 14.0917 14.1479 14.0336 13.9191 13.9298C13.9157 13.9298 13.3765 13.6306 13.1979 13.3371Z'
          fill='url(#paint2_linear_12280_30175)'
          stroke='url(#paint3_linear_12280_30175)'
          strokeWidth='0.3'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.17451 13.3371C7.79609 12.8772 7.42995 12.0734 7.54492 10.6691C7.73023 8.39194 10.2017 7.32031 10.2017 7.32031L10.656 8.01241C10.656 8.01241 9.26511 8.76366 9.39013 10.4939C9.47385 10.4827 9.55758 10.4771 9.64353 10.4771C10.6415 10.4771 11.4519 11.2865 11.4519 12.2844C11.4519 13.2812 10.6415 14.0917 9.64353 14.0917C9.37785 14.0917 9.12446 14.0336 8.89562 13.9298C8.89227 13.9298 8.35311 13.6306 8.17451 13.3371Z'
          fill='url(#paint4_linear_12280_30175)'
          stroke='url(#paint5_linear_12280_30175)'
          strokeWidth='0.3'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_30175'
          x1='4.96985'
          y1='3.46064'
          x2='13.4467'
          y2='23.2921'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_30175'
          x1='4.96985'
          y1='3.46064'
          x2='13.4467'
          y2='23.2921'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_30175'
          x1='13.3604'
          y1='7.78204'
          x2='17.179'
          y2='12.2224'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_30175'
          x1='13.3604'
          y1='7.78204'
          x2='17.179'
          y2='12.2224'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_30175'
          x1='8.33693'
          y1='7.78204'
          x2='12.1556'
          y2='12.2224'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_30175'
          x1='8.33693'
          y1='7.78204'
          x2='12.1556'
          y2='12.2224'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_30175'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Quote;
